import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppStateService } from 'src/app/shared/services/app-state.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

  constructor(private appstate:AppStateService,private router:Router) { }

  ngOnInit(): void {
  }

  routeToDashboard(){
    let user = this.appstate.user;
    if (user.isAdmin) {
      this.router.navigate(["/admin/projects"]);
    }else{
      this.router.navigate(["/user/map"]);
    }
  }

}
